import React, { ReactNode } from 'react'
import { Stack } from '@mui/material'
import { CustomStyles, getStyles } from '@utils/styles'
import defaultStyles, { StylesClassNames } from './styles'

type Props = {
  children: ReactNode
  csx?: CustomStyles<StylesClassNames>
}
export function SectionContainer({ children, csx }: Props) {
  const styles = getStyles(defaultStyles, csx)

  return <Stack {...styles('wrapper')}>{children}</Stack>
}
